import { CAN_USE_DOM } from 'src/constants/other';

type PrayerStatsData = {
  prayersCount: number;
  totalDuration: number;
  prayers: Record<string, { startTime: number; endTime: number }>;
  totalPoints: number;
};

class PrayerStats {
  private _prayersCount: number;
  private _userId: string;
  private _prayers: Record<string, { startTime: number; endTime: number }>;
  private _totalDuration: number;
  private _totalPoints: number;

  constructor() {
    this._prayersCount = 0;
    this._prayers = {};
    this._userId = '';
    this._totalDuration = 0;
    this._totalPoints = 0;
  }

  get totalDuration() {
    return this._totalDuration;
  }

  get totalPoints() {
    return this._totalPoints;
  }

  get prayersCount() {
    return this._prayersCount;
  }

  init = (userId: string) => {
    if (CAN_USE_DOM) {
      const lsData = localStorage.getItem(`prayerStats`);

      this._userId = userId;

      if (lsData) {
        const { prayersCount, totalDuration, prayers, totalPoints } = JSON.parse(lsData);
        this._prayersCount = prayersCount;
        this._prayers = prayers;
        this._totalDuration = totalDuration;
        this._totalPoints = totalPoints;
      }
    }
  };

  getDurationByPrayerId = (id: string) => {
    const prayer = this._prayers[id];

    if (!prayer) return 0;

    return prayer.endTime - prayer.startTime;
  };

  startPrayer = (id: string) => {
    this._prayers[id] = { startTime: Date.now(), endTime: 0 };

    localStorage.setItem(
      `prayerStats`,
      JSON.stringify({
        prayersCount: this._prayersCount,
        totalDuration: this._totalDuration,
        prayers: { ...this._prayers, [id]: this._prayers[id] },
        totalPoints: this._totalPoints,
      })
    );
  };

  endPrayer = (id: string) => {
    const prayer = this._prayers[id];
    const lsPrayer: PrayerStatsData | null = JSON.parse(localStorage.getItem(`prayerStats`) ?? '{}');

    if (!prayer || lsPrayer?.prayers[id].endTime) return;

    prayer.endTime = Date.now();

    this._prayersCount++;
    this._totalDuration += Date.now() - prayer.startTime;
    this._totalPoints += 25;

    localStorage.setItem(
      `prayerStats`,
      JSON.stringify({
        prayersCount: this._prayersCount,
        totalDuration: this._totalDuration,
        prayers: { ...this._prayers, [id]: prayer },
        totalPoints: this._totalPoints,
      })
    );
  };
}

export function convertMilliseconds(ms: number) {
  if (ms < 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

  const seconds = Math.floor((ms / 1000) % 60);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));

  return { days, hours, minutes, seconds };
}

export default new PrayerStats();
